import Alpine from "alpinejs";

import { isCustomEvent, MODAL_EVENTS } from "@app/lib/events";

import "./modal.css";

Alpine.data("modal", (initialOpen?: boolean) => {
  return {
    // State
    isOpen: initialOpen ?? false,
    id: undefined as string | undefined,

    // State Modifiers
    handleOpen() {
      this.isOpen = true;
    },
    handleClose() {
      this.isOpen = false;
      this.handleRemoveAnchor();
    },
    handleToggle() {
      if (this.isOpen) this.handleClose();
      else this.handleOpen();
    },

    // Utility Methods
    hasHash() {
      return this.id && location.hash.endsWith(this.id);
    },

    handleRemoveAnchor() {
      if (!this.hasHash()) return;
      /** Replace the state */
      window.history.replaceState({}, "", location.pathname);
    },

    // Event Handlers
    handleEventOpen(event: Event) {
      if (!isCustomEvent(event)) return;
      if (event.detail.target !== this.id) return;
      this.handleOpen();
    },

    handleEventClose(event: Event) {
      if (!isCustomEvent(event)) return;
      if (event.detail.target !== this.id) return;
      this.handleClose();
    },

    handleAnchorOpen() {
      if (!this.hasHash()) {
        return;
      }
      this.handleOpen();
    },

    // Lifecycle Hooks
    init() {
      this.id = this.$root.id;
      Alpine.bind(this.$root, this.root);
      document.addEventListener(MODAL_EVENTS.OPEN, this.handleEventOpen.bind(this));
      document.addEventListener(MODAL_EVENTS.CLOSE, this.handleEventClose.bind(this));
      window.addEventListener("hashchange", this.handleAnchorOpen.bind(this));
      window.addEventListener("load", this.handleAnchorOpen.bind(this));
    },
    destroy() {
      document.removeEventListener(MODAL_EVENTS.OPEN, this.handleEventOpen.bind(this));
      document.removeEventListener(MODAL_EVENTS.CLOSE, this.handleEventClose.bind(this));
      window.removeEventListener("hashchange", this.handleAnchorOpen.bind(this));
      window.removeEventListener("load", this.handleAnchorOpen.bind(this));
    },

    // Bound Directives
    root: {
      [":data-ui"]() {
        return !this.isOpen && "hidden";
      },
    },
    toggle: {
      ["@click"]() {
        this.handleToggle();
      },
    },
    open: {
      ["@click"]() {
        this.handleOpen();
      },
    },
    close: {
      ["@click"]() {
        this.handleClose();
      },
    },
    portal: {},
    content: {
      ["x-show"]() {
        return this.isOpen;
      },
      ["@click.outside"]() {
        this.handleClose();
      },
    },
    openContent: {
      ["x-show"]() {
        return this.isOpen;
      },
    },
  };
});
